var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercorrenzaRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E53929;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,1.8c2.3-0.5,4.8-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.4c1.1,1.9,1.6,4.1,1.3,6.2c-0.3,1.9-1.1,3.6-2.1,5.1 c-0.9,1.4-2,2.6-3,3.9c-1.8,2.1-3.6,4.3-5.4,6.4c-2.1-2.2-4.1-4.5-6.1-6.8c-1.3-1.5-2.6-3.2-3.5-5c-0.9-1.9-1.2-4-0.9-6.1 c0.3-2.2,1.3-4.2,2.8-5.8C8.8,3.3,10.6,2.2,12.6,1.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 15,
    y1: 1.6,
    x2: 15,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 15,
    y1: 2.1,
    x2: 15,
    y2: 23.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercorrenzaRed);
export default __webpack_public_path__ + "static/media/percorrenza_red.9f4b655d7f7f6874ceacb0302b0a583e.svg";
export { ForwardRef as ReactComponent };